import React, { useContext, useMemo } from 'react';
import { Grid, Typography } from "@mui/material";
import {
    ERROR_COLOR,
    INFO_COLOR,
    PRIMARY_COLOR,
    SECONDARY_COLOR,
    SUCCESS_COLOR,
    TERTIARY_COLOR
} from "../../../constants/Colors";
import { ChartContext } from "../../../contexts/ChartContext";
import { addThousandSeparator } from "../../../utilities/Others";

function VillageTotalAreaAndPrice({ item, classes, styles }) {

    const { data } = useContext(ChartContext);

    const floorOrder = {
        Ground: 1,
        'Al Fresco': 2,
        First: 3,
        Second: 4,
    };

    const { totalArea, totalPrice, isLastRow } = useMemo(() => {

        const sameUnits = data.filter(d => d.unit === item.unit);

        if (!sameUnits.length) {
            return { totalArea: 0, totalPrice: 0, isLastRow: false };
        }

        const getOrder = (name) => floorOrder[name] ?? 999;

        const calculableFloors = sameUnits.filter(
            d => d.floorName !== 'Al Fresco'
        );

        const totalArea = calculableFloors.reduce(
            (sum, d) => sum + (d.grossArea || 0),
            0
        );

        const totalPrice = sameUnits.reduce((sum, d) => {
            const cleaned = typeof d.price === 'string'
                ? parseFloat(d.price.replace(/[^\d.-]/g, ''))
                : d.price;

            return sum + (isNaN(cleaned) ? 0 : cleaned);
        }, 0);

        const lastFloorItem = sameUnits.reduce((max, curr) => {
            return getOrder(curr.floorName) > getOrder(max.floorName)
                ? curr
                : max;
        }, sameUnits[0]);

        return {
            totalArea,
            totalPrice,
            isLastRow: lastFloorItem?.id === item.id
        };

    }, [data, item.id, item.unit]);

    if (!isLastRow) return null;

    return (
        <Grid container mb={0.5} pr={{ xs: 0.5 }}>

            {/* Unit Name */}
            <Grid item xs={1.5}
                  pr={{xs: 0.5, sm: 0.5, md: 0.5}}
                  // mb={0.5}
            >
                <div className={classes.itemContainer}>
                    <Typography variant='body2'
                                sx={[styles.title, {color: SECONDARY_COLOR}]}
                    >
                        Total
                    </Typography>
                </div>
            </Grid>

            {/* Unit Name */}
            <Grid item xs={1.5} pr={{xs: 0.5, sm: 0.5, md: 0.5}}>
                <div className={classes.itemContainer}
                     style={{
                         backgroundColor: item.unitStatus === 'SOLD' ? ERROR_COLOR :
                             item.unitStatus === 'RESERVED' ? INFO_COLOR :
                                 item.unitStatus === 'AVAILABLE' ? SUCCESS_COLOR : TERTIARY_COLOR,
                         position: 'relative'
                     }}
                >
                    <Typography variant='body2' sx={[styles.title, { fontWeight: 400 }]}>
                        {item.unit}
                    </Typography>
                </div>
            </Grid>

            <Grid item xs={2.03}
                  pr={{xs: 0.5, sm: 0.5, md: 0.5}}
            >
                <div className={classes.itemContainer}>
                    <Typography variant='body2'
                                sx={[styles.title, {color: SECONDARY_COLOR}]}
                    >
                        {totalArea
                            ? addThousandSeparator(totalArea.toString())
                            : null}
                    </Typography>
                </div>
            </Grid>

            {/* Total Area */}
            <Grid item xs={2.5} pr={{xs: 0.5, sm: 0.5, md: 0.5}}>
                <div className={classes.itemContainer}>
                    <Typography sx={[styles.title, { fontWeight: 500 }]}>
                        -
                    </Typography>
                </div>
            </Grid>

            {/* Total Price */}
            <Grid item xs={3}>
                <div className={classes.itemContainer}>
                    <Typography sx={[styles.title, { fontWeight: 500 }]}>
                        {totalPrice
                            ? addThousandSeparator(totalPrice.toString())
                            : null}
                    </Typography>
                </div>
            </Grid>

        </Grid>
    );
}

export default VillageTotalAreaAndPrice;